import { AdDetails } from '@/api/types/ads.types';
import { ROUTES } from '@/constants/routes';

export function buildWorkingScheduleString(shop?: AdDetails['shop']) {
  if (!shop) return '';
  return `${shop.workingDays} ${shop.workingHours}`;
}

export function getUsersAdsHref(userLegacyId: number) {
  const searchParams = new URLSearchParams({
    user_id: userLegacyId.toString(),
  });

  return `${ROUTES.ad}?${searchParams.toString()}`;
}
